import Config from '@config';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import { infiniteQueryOptions } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { FiltersGrid, Pagination } from '../types';
import { MeteringDeviceConsumerIndicator } from './types';

export const meteringDeviceConsumerIndicatorApi = createApi({
  reducerPath: 'meteringDeviceConsumerIndicatorApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/metering-device-consumer-indicators`,
  }),
  tagTypes: ['MeteringDeviceConsumerIndicator'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeteringDeviceConsumerIndicators: builder.query<
      MeteringDeviceConsumerIndicator[],
      FiltersGrid
    >({
      query: params => ({
        url: '/query',
        params,
      }),
    }),
    getMeteringDeviceConsumerIndicatorsI: builder.infiniteQuery<
      MeteringDeviceConsumerIndicator[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        params: { ...queryArg, ...pageParam },
      }),
    }),
  }),
});

export const { useGetMeteringDeviceConsumerIndicatorsQuery } =
  meteringDeviceConsumerIndicatorApi;

export const useGetMeteringDeviceConsumerIndicatorsInfiniteQuery =
  normalizeInfiniteQueryData(
    meteringDeviceConsumerIndicatorApi.useGetMeteringDeviceConsumerIndicatorsIInfiniteQuery,
  );
